import type { Report } from "../../lib/api/index.js";
import { countryLabel, languageLabel } from "../../lib/markets.js";
import { CountryFlag } from "../country-flag.js";
import { InfoTip } from "../info-tip.js";
import { ReportFilters } from "../report-filters.js";

/**
 * What every number on a brand's screen is narrowed to: dates, engine, market
 * (DESIGN.md §5, "the lens").
 *
 * The dates and the engine live in the address, so the screen below reads the
 * same values these pills write. The market is the brand's own and is not a
 * filter — every question is asked in it — so it is shown, not offered.
 */
export function Lens({
  report,
  today,
}: {
  readonly report: Report;
  readonly today: Date;
}) {
  const { country, language } = report.brand;
  return (
    <div className="appbar-lens" role="search" aria-label="Filters" data-tour="filters">
      <ReportFilters today={today} />
      <span className="appbar-market">
        <CountryFlag code={country} />
        {countryLabel(country)}
        <InfoTip label="Market">
          Every question for {report.brand.name} is asked in {countryLabel(country)}, in{" "}
          {languageLabel(language)}. The market is set per brand, in Settings.
        </InfoTip>
      </span>
    </div>
  );
}
